var map = {
	"./video_1.png": 1310,
	"./video_2.png": 3693,
	"./video_3.png": 3481,
	"./video_4.png": 2550,
	"./video_5.png": 1371,
	"./video_6.png": 8109,
	"./video_7.png": 8209,
	"./video_8.png": 3926
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5118;